import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import { TextInput, TextInputProps } from './TextInput';

export function TextInputForm<T extends FieldValues>({
  control,
  name,
  defaultValue,
  ...rest
}: UseControllerProps<T> & Omit<TextInputProps, 'value' | 'onValueChanged'>) {
  const {
    field,
    fieldState: { invalid, error },
  } = useController({ control, name, defaultValue });

  return (
    <TextInput
      value={field.value}
      onValueChanged={field.onChange}
      error={error?.message}
      {...rest}
    />
  );
}
